<template>
    <div
        class="campaign-reporting-filter-container"
        data-qa="campaign-reporting-filter-button"
        @click="$emit('on-open-filter-modal')"
    >
        <DsChip with-interaction>
            <template #leading>
                <img src="/resources/funnel/images/svg/filter.svg" />
            </template>

            <span data-qa="filter-button-label">{{ filterButtonLabel }}</span>
        </DsChip>
    </div>
</template>

<script>
import { PRESET_FILTERS } from '../utils/editor.constants';

export default {
    props: {
        preset: {
            type: String,
            default: () => PRESET_FILTERS.LAST_24_HOURS,
        },
    },
    emits: ['on-open-filter-modal'],
    computed: {
        filterButtonLabel() {
            const datePrefix = this.$t('funnel.campaign.reporting.filter.preset.label.datePrefix');
            const presetLabel = this.$t(`funnel.campaign.reporting.filter.preset.label.${this.preset}`);

            return `${datePrefix}: ${presetLabel}`;
        },
    },
};
</script>

<style scoped lang="scss">
.campaign-reporting-filter-container {
    overflow: visible;
    height: 0;
    position: relative;
    z-index: 50;
}
</style>
